/* Flipper Feature flags to be imported into state, where they can be accessed
 * globally.
 *
 * shape:
 * state.clientFeatureFlags = {
 *   'client.global.kids_categories': true
 * }
 */

export const featureFlags = [
  // https://admin-proxy.production.int.stitchfix.com/client-context-service/admin/flipper/features/client.global.kids_categories
  'client.global.kids_categories',
  'client.feedback_thumbs_enabled',
];
